import React, { useEffect, useState } from 'react';
import Slideshow from './Slideshow';
import { MarkDownView } from '../../common/MarkDownView';

function KvizPitanjeMulti({
    item,
    pitanjeIndex,
    surveyOdgovori,
    setSurveyOdgovori,
    showResults = false,
}: {
    item: any;
    pitanjeIndex: number;
    surveyOdgovori: any;
    setSurveyOdgovori: any;
    showResults?: boolean;
}) {
    const tacniOdgovori = item.odgovori.filter((odgovor: any) => odgovor.tacan);
    const [showOpis, setShowOpis] = useState(false);
    const hasOpis = !!item?.opis?.trim();

    // Posle završetka testa opis odgovora se automatski otvara za pitanja koja nisu tačno rešena (ili nisu rešena).
    const osvojenoBodova = surveyOdgovori?.[pitanjeIndex]?.brojBodova ?? 0;
    useEffect(() => {
        if (showResults && osvojenoBodova < 1) setShowOpis(true);
    }, [showResults, osvojenoBodova]);

    return (
        <div className="flex flex-col  pb-3 border-b border-b-blueHoverLight">
            <div className="flex flex-row gap-5 justify-between ">
                <div className="flex-1">
                    <div className="flex flex-col justify-between gap-2 ">
                        <div className="flex flex-row gap-2">
                            <p className="text-[16px] leading-5 text-blueDark font-medium"> {pitanjeIndex + 1}.</p>
                            <MarkDownView source={item.naziv} />
                        </div>
                        {item.oblastImages && item.oblastImages?.length !== 0 && (
                            <div className="block xl:hidden">
                                <Slideshow images={item.oblastImages} width={300} height={200} />
                            </div>
                        )}
                    </div>
                    <p className="text-[14px] leading-5 text-yellow-900 font-medium mt-2"> Pitanje ima više od jednog tačnog odgovora</p>
                    <div className="flex flex-col gap-2 mt-2">
                        {item.odgovori?.map((odgovor: any, index: number) => {
                            return (
                                <Odgovor
                                    item={item}
                                    odgovor={odgovor}
                                    key={odgovor?.id}
                                    pitanjeIndex={pitanjeIndex}
                                    surveyOdgovori={surveyOdgovori}
                                    setSurveyOdgovori={setSurveyOdgovori}
                                    showResults={showResults}
                                />
                            );
                        })}
                    </div>
                </div>
                {item.oblastImages && item.oblastImages?.length !== 0 && (
                    <div className="hidden xl:block">
                        <Slideshow images={item.oblastImages} width={300} height={200} />
                    </div>
                )}
            </div>
            {showResults && (
                <div className="flex flex-col gap-2 mt-3">
                    <p className="text-[14px] md:text-[16px] tracking-tight leading-5 text-greenA700 font-medium"> Tačni odgovori su: </p>
                    <div className="flex flex-col gap-1">
                        {tacniOdgovori?.map((item: any, index: number) => {
                            return <MarkDownView style={{ color: '#00c853' }} source={item?.text} key={index} />;
                        })}
                    </div>
                    <p className="text-[16px] leading-5 text-blueDark font-bold">
                        Osvojeno bodova: {(surveyOdgovori[pitanjeIndex] && surveyOdgovori[pitanjeIndex].brojBodova) ?? 0}
                    </p>
                    {hasOpis && (
                        <div className="mt-4">
                            <button
                                onClick={() => setShowOpis((prev: boolean) => !prev)}
                                className="text-[16px] leading-5 text-white bg-blueMedium font-medium px-4 py-2 mb-2 text-left rounded-[10px] transition"
                            >
                                {showOpis ? 'Zatvori opis odgovora' : 'Prikaži opis odgovora'}
                            </button>

                            <div
                                className={`bg-orange-50 rounded-lg p-2 ${showOpis ? 'max-h-[1000px] h-auto' : 'max-h-0'} ${showOpis ? 'opacity-100 p-1' : 'opacity-0'} overflow-hidden transition-all`}
                            >
                                <MarkDownView source={item?.opis} />
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default KvizPitanjeMulti;

const Odgovor = ({
    item,
    odgovor,
    surveyOdgovori,
    setSurveyOdgovori,
    pitanjeIndex,
    showResults = false,
}: {
    item: any;
    odgovor: any;
    surveyOdgovori: any;
    setSurveyOdgovori: any;
    pitanjeIndex: any;
    showResults?: boolean;
}) => {
    const handleSelectOdgovor = (odgovor: any) => {
        setSurveyOdgovori((prethodnaLista: any[]) => {
            const novaLista = [...prethodnaLista]; // Kopiramo listu
            const trenutniPodaci = novaLista[pitanjeIndex] || { odgovori: [], brojBodova: 0 }; // Inicijalizujemo objekat ako ne postoji

            // Proveravamo da li odgovor već postoji u listi
            const odgovorIndex = trenutniPodaci.odgovori.findIndex((o: any) => o.id === odgovor.id);

            let noviOdgovori;
            if (odgovorIndex === -1) {
                // Ako ne postoji, dodajemo ga u listu
                noviOdgovori = [...trenutniPodaci.odgovori, odgovor];
            } else {
                // Ako postoji, uklanjamo ga iz liste
                noviOdgovori = trenutniPodaci.odgovori.filter((o: any) => o.id !== odgovor.id);
            }

            // Formiramo novi objekat sa ažuriranom listom odgovora i ponovo izračunanim brojem bodova
            novaLista[pitanjeIndex] = {
                odgovori: noviOdgovori,
                brojBodova: calculateMultiOdgovor(noviOdgovori), // Ponovo računamo broj bodova
            };
            console.log('nova lista', novaLista);
            return novaLista;
        });
    };
    const calculateMultiOdgovor = (listaOdgovoraZaKalkulaciju: any) => {
        console.log('ovo je lista za kalku', listaOdgovoraZaKalkulaciju, item.odgovori);
        // Lista svih ponuđenih odgovora (item.odgovori)
        const odgovori = item.odgovori;

        // Pronađi sve tačne odgovore iz ponuđenih odgovora (item.odgovori)
        const tacniOdgovori = odgovori?.filter((odgovor: any) => odgovor.tacan);

        // Filtriraj datu listu odgovora (surveyOdgovori) koja je odabrana za trenutno pitanje
        const odgovoriZaPitanje = listaOdgovoraZaKalkulaciju;

        // Pronađi tačne odgovore u korisničkim odgovorima
        const tacniOdgovoriKorisnika =
            odgovoriZaPitanje?.filter((odgovor: any) => tacniOdgovori.some((tacan: any) => tacan.id === odgovor.id && tacan.tacan)) || [];

        // Izračunaj procenat tačnih odgovora (0-1)
        let procenatTacnih = tacniOdgovoriKorisnika.length / tacniOdgovori.length;

        // Pronađi netačne odgovore korisnika
        const netacniOdgovori = odgovoriZaPitanje?.filter((odgovor: any) => !odgovor.tacan) || [];

        // Ako postoji jedan netačan odgovor, smanjite procenat tačnosti za 50%
        if (netacniOdgovori.length === 1) {
            procenatTacnih = procenatTacnih * 0.5;
        }
        // Ako postoji više od jednog netačnog odgovora, smanjite procenat na 0
        else if (netacniOdgovori.length > 1) {
            procenatTacnih = 0;
        }

        // Zaokruži procenat na dve decimale
        return parseFloat(procenatTacnih.toFixed(2));
    };

    const hasOdgovori = surveyOdgovori[pitanjeIndex] && surveyOdgovori[pitanjeIndex].odgovori;

    return (
        <button
            className={`w-full max-w-[450px]  ${
                showResults && hasOdgovori && surveyOdgovori[pitanjeIndex].odgovori.some((el: any) => el.id === odgovor.id) && odgovor?.tacan
                    ? 'bg-greenA200'
                    : showResults && hasOdgovori && surveyOdgovori[pitanjeIndex].odgovori.some((el: any) => el.id === odgovor.id) && !odgovor?.tacan
                      ? 'bg-redA200'
                      : hasOdgovori && surveyOdgovori[pitanjeIndex].odgovori.some((el: any) => el.id === odgovor.id)
                        ? 'bg-grey-300'
                        : 'bg-grey-100'
            } flex flex-row gap-4 px-2 md:px-4 py-2 rounded-[10px] transition`}
            onClick={() => handleSelectOdgovor(odgovor)}
            disabled={showResults}
        >
            <div className="border-[1.5px] border-blueDark rounded-full h-[18px] min-w-[18px] flex items-center justify-center mt-[2px]">
                <div
                    className={`rounded-full h-[10px] w-[10px] ${hasOdgovori && surveyOdgovori[pitanjeIndex].odgovori.some((el: any) => el.id === odgovor.id) ? 'bg-blueDark' : ''} transition`}
                ></div>
            </div>
            <MarkDownView source={odgovor.text} />
        </button>
    );
};
